import { AppRouteType } from 'layouts/helper';
import routesMap from 'layouts/routesMap';
import { memoize } from 'lodash';
import { lazy } from 'react';

// const HomePage = lazy(() => import('pages/HomePage'));

// cấu hình
// const CaiDatPage = lazy(() => import('pages/CaiDat'));
const CauHinhTaiKhoanPage = lazy(() => import('pages/CaiDat/CauHinhTaiKhoanPage'));
const CauHinhDiaChiNhanPage = lazy(() => import('pages/CaiDat/CauHinhDiaChiNhanPage'));
const CauHinhTKThanhToanPage = lazy(() => import('pages/CaiDat/CauHinhTKThanhToanPage'));
const DoiMatKhauPage = lazy(() => import('pages/CaiDat/DoiMatKhauPage'));

// tạo đơn
const TaoDonLePage = lazy(() => import('pages/TaoDon/TaoDonLePage'));
const TaoDonExcelPage = lazy(() => import('pages/TaoDon/TaoDonExcelPage'));
const LichSuTaiFilePage = lazy(() => import('pages/TaoDon/TaoDonExcelPage/LichSuTaiFilePage'));
// quản lý đơn hàng
const QuanLyDonHangPage = lazy(() => import('pages/QuanLy/QuanLyDonHangPage'));
const ThongTinDonhangPage = lazy(() => import('pages/QuanLy/ThongTinDonHangPage'));
const ThongKeTienHangPage = lazy(() => import('pages/QuanLy/ThongKeTienHangPage'));
// tra cứu
const UocTinhCuocPage = lazy(() => import('pages/TraCuu/UocTinhCuocPage'));
// hỏi đáp , hỗ trợ
const KhieuNaiPage = lazy(() => import('pages/HoTro/KhieuNaiPage'));

// thông báo
const ThongBaoPage = lazy(() => import('pages/ThongBaoPage'));

const routes: AppRouteType[] = [
  {
    path: routesMap.HOME,
    component: ThongKeTienHangPage,
  },
  // {
  //   path: routesMap.CAU_HINH_TAI_KHOAN_ROOT,
  //   component: CaiDatPage,
  // },
  {
    path: routesMap.CAU_HINH_TAI_KHOAN,
    component: CauHinhTaiKhoanPage,
  },
  {
    path: routesMap.CAU_HINH_DIA_CHI_NHAN,
    component: CauHinhDiaChiNhanPage,
  },
  {
    path: routesMap.CAU_HINH_TAI_KHOAN_THANH_TOAN,
    component: CauHinhTKThanhToanPage,
  },
  {
    path: routesMap.DOI_MAT_KHAU,
    component: DoiMatKhauPage,
  },
  {
    path: routesMap.TAO_DON_LE,
    component: TaoDonLePage,
  },
  {
    path: routesMap.TAO_DON_EXCEL,
    component: TaoDonExcelPage,
  },
  {
    path: routesMap.LICH_SU_TAI_FILE,
    component: LichSuTaiFilePage,
  },
  {
    path: routesMap.CHI_TIET_LICH_SU_FILE,
    component: TaoDonExcelPage,
  },
  {
    path: routesMap.QUAN_LY_DON_HANG,
    component: QuanLyDonHangPage,
  },
  {
    path: routesMap.THONG_KE_TIEN_HANG,
    component: ThongKeTienHangPage,
  },
  {
    path: routesMap.TRA_CUU_DON_HANG,
    component: ThongTinDonhangPage,
  },
  {
    path: routesMap.UOC_TINH_CUOC,
    component: UocTinhCuocPage,
  },
  {
    path: routesMap.KHIEU_NAI,
    component: KhieuNaiPage,
  },
  {
    path: routesMap.THONG_BAO,
    component: ThongBaoPage,
  },
];

const getRoutePrivate = memoize(() => {
  return routes;
});

export default getRoutePrivate;
